export const classDoNotExpandobjectInspectorOnClick = "do-not-expand-object-inspector-on-click";

/**
 * Indicates whether an `Element`, when clicked, should prevent expanding the object `<Inspector>`
 * on click. This is done by checking for a special CSS class in `Element` or any of its ancestors.
 */
export function hasClassDoNotExpandObjectInspectorOnClick(e: Element | null) {
	const closest = e?.closest(`.${classDoNotExpandobjectInspectorOnClick}`);
	return closest !== undefined && closest !== null;
}
